@if (!router.url.includes('tenants')) {
  <app-header />
}

<div class="lay-wrapper lay-wrapper--content lay-wrapper--mains" [class.tenants]="router.url.includes('tenants')">
  <router-outlet #outlet="outlet"></router-outlet>
</div>

<app-gt-footer />
